import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { SummaryTitleStyled } from '../SummaryTitleStyled';
import { rem } from 'polished';

export const SummaryTitleDS = styled(SummaryTitleStyled)`
    h3 {
        font-size: ${rem(32)};

        @media (max-width: ${breakpoints.xs}px) {
            font-size: ${rem(24)};
        }
    }

    p {
        font-size: ${({ theme }) => theme.fontSizes.h4};

        @media (max-width: ${breakpoints.xs}px) {
            font-size: ${rem('16px')};
            margin-top: ${rem('10px')};
        }
    }
`;
